import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { IChatBotV2SesionData } from '../../../../models/chat-bot-v2.model';
import { ChatBotV2DataService } from '../../../../services/chat-bot-v2/chat-bot-v2.data.service';

@Component({
  selector: 'app-chat-bot-asesor-v2-dashboard-filtros',
  templateUrl: './chat-bot-asesor-v2-dashboard-filtros.component.html',
})
export class ChatBotAsesorV2DashboardFiltrosComponent implements OnInit {
  @Input() dataSinFiltrar: IChatBotV2SesionData[] = [];
  @Input() dataSource: MatTableDataSource<IChatBotV2SesionData>;

  periodos: { name: string; value: string }[] = [
    { name: 'Todos', value: undefined },
    { name: '7 días', value: '7' },
    { name: '30 días', value: '30' },
    { name: 'Más antiguas', value: '30+' },
  ];

  form = new FormGroup({
    periodo: new FormControl(),
    text: new FormControl(''),
  });

  constructor(
    public chatBotV2DS: ChatBotV2DataService,
  ) {
    this.form.valueChanges.subscribe(() => this.filtrar());
  }

  ngOnInit(): void {
    this.dataSource.filterPredicate = (data, filter) => this.filterPredicate(data, filter);
  }
  
  filterPredicate(data: IChatBotV2SesionData, filter: string): boolean {
    const results: boolean[] = [];
    try {
      const { fechaCreacion, titulo } = data;
      const { periodo, text } = JSON.parse(filter || '{}');

      if (periodo) results.push(this.getRangeDates(fechaCreacion, periodo));
      if (text) results.push(titulo.includes(text));
      
    } catch (error) {
      console.log(error);
    }
    return results.every(f => f);
  }

  filtrar() {
    this.chatBotV2DS.poseeFiltros = this.getPoseeFiltro();
    this.dataSource.filter = JSON.stringify(this.form.value);
  }

  private getPoseeFiltro(): boolean {
    return Object.values(this.form.value).some(v => !!v);
  }

  private getRangeDates(fechaComparar: string, periodo: string): boolean {
    const end = new Date();
    const start = new Date();
    const date = new Date(fechaComparar);
    switch (periodo) {
      case '7':
        end.setDate(end.getDate() - 7);
        break;
      case '30':
        end.setDate(end.getDate() - 30);
        break;
      case '30+':
        start.setDate(start.getDate() - 30);
        end.setTime(0);
        break;
      default:
        return true;
    }
    return (start.getTime() >= date.getTime()) && (end.getTime() <= date.getTime());
  }



}
